import { useNavigate, useLocation } from 'react-router-dom';

export function useRedirectBack() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const configuratorId = queryParams.get('configuratorId');
  const configurationId = queryParams.get('configurationId');

  const redirectUrl = configuratorId ? `/configurator/${configuratorId}/${configurationId}` : '/';

  return {
    targetConfigurator: configuratorId,
    redirectBack: () => {
      navigate(redirectUrl, { replace: true });
    }
  };
}
